<app-table-component
  [data]="alertsList()"
  [columns]="tableColumns"
  [totalRecords]="totalRecords()"
  [rows]="rows"
  [first]="first"
  (pageChange)="onPageChange($event)"
  [searchControl]="searchControl"
  [customFilters]="customFilters"
  [showColumnSelector]="false"
  [showClearFilters]="true"
  searchPlaceholder="Search by vehicle or alert ID"
/>

<p-dialog
  [(visible)]="payloadDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '42rem' }"
  [breakpoints]="{ '575px': '95vw' }"
  header="Raw Payload"
>
  <pre class="payload-pre">{{ parsedPayload }}</pre>
</p-dialog>
